import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { useEffect, useState } from "react";
import { authRequest } from "../../../../common/request/authRequest";
import { Progress } from "antd";
import { CheckCircleFilled, CheckCircleOutlined, CloseCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";

export const PendingCredits = (props: { neededCredits: number }) => {

	const { projectGroup } = useAuth();
    const [creditsPlan, setCreditsPlan] = useState<any>(null);        
    
	useEffect(() => {        
        authRequest(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/available-credits',{ method: 'GET' })
            .then((data) => {                
                setCreditsPlan(data);                
            })            
    }, []); 	

	return (
		<>
			{creditsPlan && 				
				<div style={{ width: '100%', padding:'10px', background: 'white', color: 'slategrey', border:'.5px solid silver' }}>
					<div>Esta acción consumirá <b>{props.neededCredits} créditos</b> </div>
					<small>Quedan {creditsPlan.credits} créditos disponibles</small>					
				</div>
			}
		</>
	)
}